import { Row } from "views/applications-id-report/components/Row";
import { formatPhone } from "shared/utils";
import type { BrandingPreview as BrandingPreviewValues } from "api/branding";

const getLogoUrl = (logo: BrandingPreviewValues["logo"]) => {
  if (!logo) return undefined;
  return typeof logo === "string" ? logo : logo.asset?.url;
};

// Read-only view of a branding set; blank facets fall back to Boom's default look.
export const BrandingPreview = ({
  branding
}: {
  branding: BrandingPreviewValues;
}) => {
  const logoUrl = branding.logo_url ?? getLogoUrl(branding.logo);

  return (
    <div className="space-y-4">
      <Row
        title="Logo"
        value={
          logoUrl ? (
            <img
              src={logoUrl}
              alt="Logo"
              className="h-10 max-w-[160px] w-auto object-contain"
            />
          ) : (
            "Boom default"
          )
        }
      />
      <Row
        title="Primary color"
        value={
          branding.primary_color ? (
            <span className="inline-flex items-center gap-2">
              <span
                className="size-4 rounded border border-alpha-100"
                style={{ backgroundColor: branding.primary_color }}
              />
              {branding.primary_color}
            </span>
          ) : (
            "Boom default"
          )
        }
      />
      <Row title="Landlord name" value={branding.landlord_name || "—"} />
      <Row
        title="Landlord phone"
        value={
          branding.landlord_phone ? formatPhone(branding.landlord_phone) : "—"
        }
      />
      <Row title="Landlord email" value={branding.landlord_email || "—"} />
    </div>
  );
};
